module.exports = __webpack_public_path__ + "img/new1.11828c8c.png";